import React, { useState, useEffect } from 'react';
import {
    Container, Box, TextField, Button, Dialog, DialogContent,
    DialogTitle, MenuItem, IconButton, InputAdornment,
    Tooltip, Typography
} from '@mui/material';
import Swal from 'sweetalert2';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import axios from 'axios';
import ReusableTable from '../components/tables/resuabletable';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { AuthContext } from '..';
import { useContext } from 'react';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Token } from '@mui/icons-material';
import { tr } from 'date-fns/locale';



export default function Services() {
    const [errors, setErrors] = useState({});
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [openServiceDialog, setOpenServiceDialog] = useState(false);
    const [editingServiceId, setEditingServiceId] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [pdf, setPdf] = useState(false);
    const { companyid, categoryData, permissions, token } = useContext(AuthContext);
    const [editicon, setEditicon] = useState(true);
    const [deleteiocn, setDeleteicon] = useState(true);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [pagination, setPagination] = useState({
        page: 0,
        rowsPerPage: 3,
    });
    const [totalrows, setTotalrows] = useState(0);
    const handlePaginationChange = (paginationData) => {

        setPagination(paginationData);


    };
    const [opencolspaper, setOpencolspaper] = useState(false);
    const [columnOrder, setColumnOrder] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [formData, setFormData] = useState({
        serviceName: '',
        serviceCategory: '',
        basePrice: '',
        duration: 'weekly',
        taxRate: '18',
        totalAmount: '0'
    });
    useEffect(() => {
        refreshServices();
    }, [appliedFilters, pagination]);



    const validate = () => {
        const newErrors = {};
        if (!formData.serviceName) newErrors.serviceName = "Service name is required";
        if (!formData.serviceCategory) newErrors.serviceCategory = "Category is required";
        if (!formData.basePrice) newErrors.basePrice = "Base price is required";
        if (!formData.duration) newErrors.duration = "Duration is required";
        if (!formData.taxRate) newErrors.taxRate = "Tax rate is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    useEffect(() => {
        const base = parseFloat(formData.basePrice) || 0;
        const taxRate = parseFloat(formData.taxRate) || 0;
        const taxAmount = base * (taxRate / 100);
        const total = base + taxAmount;

        setFormData(prev => ({
            ...prev,
            totalAmount: total.toFixed(2)
        }));
    }, [formData.basePrice, formData.taxRate]);


    const refreshServices = () => {
        const payload = {
            filters: JSON.stringify(appliedFilters),
            currentpage: pagination.page,
            rowsPerPage: pagination.rowsPerPage
        }

        axios.get(`${process.env.REACT_APP_API_LINKS}/services/getservices`, {
            headers:
            {
                Authorization: `bearer ${token}`
            }
            , params: payload, withCredentials: true
        })
            .then(res => {
                const newColumns = res.data.columns || [];
                setColumns(newColumns);
                setColumnOrder(newColumns.filter(col => !col.hide).map(col => col.field));
                setRows(res.data.data || []);
                var numberofservices = res.data.totalrows[0];
                setTotalrows(numberofservices.totalusers);
            })
            .catch(err => {
                console.error('Error fetching services:', err);
            });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };



    const handleServiceSubmit = () => {
        if (!validate()) {
            return;
        }

        const serviceData = {
            ...formData,
            basePrice: parseFloat(formData.basePrice),
            taxRate: parseFloat(formData.taxRate),
            totalAmount: parseFloat(formData.totalAmount)
        };


        if (editingServiceId) {
            axios.put(`${process.env.REACT_APP_API_LINKS}/services/updateservice/${editingServiceId}`, serviceData,
                {
                    headers:
                    {
                        Authorization: `bearer ${token}`
                    },
                    withCredentials: true
                }
            )
                .then((res) => {
                    if (res.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Product updated successfully',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });
                        setOpenServiceDialog(false);
                        setEditingServiceId(null);
                        refreshServices();
                    }
                })
                .catch((err) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to update Product. Try again later.',
                        showConfirmButton: false,
                        timer: 2000,
                        timerProgressBar: true,
                    });
                });
        } else {
            axios.post(`${process.env.REACT_APP_API_LINKS}/services/addservice`, serviceData,
                {
                    headers:
                    {
                        Authorization: `bearer ${token}`
                    },
                    withCredentials: true
                }
            )
                .then((res) => {
                    if (res.status === 201) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Service added successfully',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });
                        setOpenServiceDialog(false);
                        refreshServices()
                    }
                })
                .catch((err) => {
                    setOpenServiceDialog(false);
                    if (err.response && err.response.status === 409) {
                        Swal.fire({
                            icon: 'warning',
                            title: 'Duplicate Service',
                            text: 'Service with same name already exists',
                            showConfirmButton: false,
                            timer: 2000,
                            timerProgressBar: true,
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Failed to add service. Try again later.',
                            showConfirmButton: false,
                            timer: 2000,
                            timerProgressBar: true,
                        });
                    }
                });
        }
    };

    const handleEdit = (service) => {
        setEditingServiceId(service.id);

        const category = categoryData?.find(item =>
            item.value.toLowerCase() === service.service_category?.toLowerCase()
        );
        setFormData({
            serviceName: service.service_name,
            serviceCategory: category?.id,
            basePrice: service.base_price,
            duration: service.price_unit,
            taxRate: service.tax_rate,
            duration: service.duration,
            totalAmount: service.total_amount || '0'
        });
        setOpenServiceDialog(true);
    };

    const handleDelete = (service) => {
        Swal.fire({
            title: `Delete service "${service.service_name}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${process.env.REACT_APP_API_LINKS}/services/deleteservice/${service.id}`,
                    {
                        headers:
                        {
                            Authorization: `bearer ${token}`
                        },
                        withCredentials: true
                    }
                )
                    .then(() => {
                        Swal.fire('Deleted!', 'product has been deleted.', 'success');
                        refreshServices();
                    })
                    .catch(() => {
                        Swal.fire('Error!', 'Failed to delete Product.', 'error');
                    });
            }
        });
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const filteredRows = rows.filter((row) => {
        const query = searchQuery.toLowerCase();
        return (
            row.service_name?.toLowerCase().includes(query) ||
            row.service_category?.toLowerCase().includes(query) ||
            row.base_price?.toString().includes(query) ||
            row.total_amount?.toString().includes(query)
        );
    });
    const filteredColumns = columnOrder
        .map(field => columns.find(col => col.field === field))
        .filter(col => col && !col.hide);
    const formatServicesData = (rows) => {


        return rows.map((row, index) => {
            const formattedRow = { S_No: index + 1 };
            filteredColumns.forEach((col) => {
                if (col.headerName === 'S.No') return;
                if (col.headerName === 'S.NO') return;
                formattedRow[col.headerName || col.field] = row[col.field] || '';
            });
            return formattedRow;
        });
    };


    const exportToExcel = () => {
        const rowsToExport = selectedIds.length > 0
            ? filteredRows.filter(row => selectedIds.includes(row.id))
            : filteredRows;

        const exportData = formatServicesData(rowsToExport);
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Services');
        XLSX.writeFile(workbook, 'services_data.xlsx');
    };

    const handlepdf = (service) => {
        // axios.get(`${process.env.REACT_APP_API_LINKS}/settings/getsettings`, { withCredentials: true })
        //     .then((res) => {
        //         if (res.status === 200) {
        //             const settings = res.data;
        //             const letterheadUrl = `${process.env.REACT_APP_API_LINKS}/headers/${settings.logo}`;
        //             const invoiceDiv = document.createElement('div');
        //             invoiceDiv.style.width = '800px';
        //             invoiceDiv.style.minHeight = '1123px';
        //             invoiceDiv.style.padding = '200px 60px 60px 60px';
        //             invoiceDiv.style.fontFamily = 'Arial, sans-serif';
        //             invoiceDiv.style.background = `url(${letterheadUrl}) no-repeat top center`;
        //             invoiceDiv.style.backgroundSize = 'contain';
        //             invoiceDiv.style.color = '#000';
        //             invoiceDiv.style.backgroundColor = '#fff';
        //             invoiceDiv.style.position = 'relative';
        //             invoiceDiv.style.left = '-9999px';
        //             invoiceDiv.style.boxSizing = 'border-box';

        //             invoiceDiv.innerHTML = `
        //             <div style="margin-bottom: 20px; text-align: right; font-size: 12px;">
        //                 <div><strong>Date:</strong> ${new Date().toLocaleDateString()}</div>
        //                 <div><strong>Time:</strong> ${new Date().toLocaleTimeString()}</div>
        //             </div>

        //             <h2 style="text-align: center; color: #0b85c8; margin: 10px 0;">Service Invoice</h2>

        //             <table style="width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 14px;">
        //                 <tr>
        //                     <th style="background: #0b85c8; color: #fff; padding: 10px;">Field</th>
        //                     <th style="background: #0b85c8; color: #fff; padding: 10px;">Value</th>
        //                 </tr>
        //                 <tr><td style="padding: 8px;">Service Name</td><td style="padding: 8px;">${service.service_name}</td></tr>
        //                 <tr><td style="padding: 8px;">Category</td><td style="padding: 8px;">${service.service_category}</td></tr>
        //                 <tr><td style="padding: 8px;">Base Price</td><td style="padding: 8px;">₹${service.base_price}</td></tr>
        //                 <tr><td style="padding: 8px;">Tax Rate</td><td style="padding: 8px;">${service.tax_rate}%</td></tr>
        //                 <tr><td style="padding: 8px;">Total Amount</td><td style="padding: 8px;">₹${service.total_amount}</td></tr>
        //                 <tr><td style="padding: 8px;">Duration</td><td style="padding: 8px;">${service.duration} Days</td></tr>
        //             </table>

        //             <div style="margin-top: 30px; text-align: center; font-size: 12px; color: #777;">
        //                 This is a system-generated invoice. No signature required.
        //             </div>
        //         `;

        //             document.body.appendChild(invoiceDiv);

        //             html2canvas(invoiceDiv, {
        //                 scale: 2,
        //                 useCORS: true,
        //             }).then((canvas) => {
        //                 const imgData = canvas.toDataURL('image/png');
        //                 const pdf = new jsPDF('p', 'pt', 'a4');
        //                 const pdfWidth = pdf.internal.pageSize.getWidth();
        //                 const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        //                 pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        //                 pdf.save(`Service_Invoice_${service.service_name}.pdf`);

        //                 document.body.removeChild(invoiceDiv);
        //             });
        //         }
        //     })
        //     .catch((err) => {
        //         console.error('Failed to fetch header/footer settings:', err);
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Error',
        //             text: 'Could not generate PDF. Header settings missing.',
        //         });
        //     });
    };

    const permissionsaccess = () => {
        const servicesmdule = permissions.services || {};
        setDeleteicon(servicesmdule.delete === true);
        setEditicon(servicesmdule.update === true);
    };
    useEffect(() => {
        if (permissions && permissions.services) {
            permissionsaccess();
        }
    }, [permissions]);






    return (
        <Container maxWidth={false} disableGutters sx={{
            px: { xs: 2, sm: 3, md: 4 },
            py: 3,
            fontFamily: 'Open Sans',
            backgroundColor: '#ffffff',
            minHeight: '100vh',
            boxShadow: { xs: 'none', sm: '0px 0px 5px rgba(187, 222, 241, 0.9)' },
            borderRadius: 2
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                justifyContent: { md: 'space-between' },
                alignItems: { md: 'center' },
                gap: 2,
                mb: 2,
            }}>
                <TextField
                    placeholder="Search by Service Name, Category or Price"
                    size="small"
                    variant="outlined"
                    sx={{
                        minWidth: 200,
                        width: { sm: 400, md: 500 },
                        backgroundColor: '#fff',
                        borderRadius: 1,
                    }}
                    value={searchQuery}
                    onChange={handleSearch}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />

                <Box sx={{
                    display: 'flex',
                    flexDirection: {
                        xs: 'row',
                        sm: 'row',
                        md: 'row',
                    },
                    justifyContent: {
                        xs: 'flex-start',
                        sm: 'space-between',
                        md: 'flex-end',
                    },
                    alignItems: 'center',
                    width: '100%',
                    gap: { xs: 1, sm: 2 },
                }}>
                    {permissions?.services?.create &&
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={() => {
                                setFormData({
                                    serviceName: '',
                                    serviceCategory: '',
                                    basePrice: '',
                                    duration: 'weekly',
                                    taxRate: '18',
                                    duration: '',
                                    totalAmount: '0'
                                });
                                setEditingServiceId(null);
                                setOpenServiceDialog(true);
                            }}
                            sx={{
                                backgroundColor: '#0b85c8',
                                fontFamily: 'Open Sans',
                                whiteSpace: 'nowrap',
                                minWidth: 'fit-content',
                                borderRadius: 2,
                                width: { xs: '100%', sm: 'auto' }
                            }}
                        >
                            Add Product
                        </Button>}
                    <Tooltip arrow title='Export to Excel'>
                        <IconButton onClick={exportToExcel} sx={{ color: '#0b85c8' }}>
                            <DownloadIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Customize Columns" arrow>
                        <IconButton
                            onClick={() => setOpencolspaper(true)}
                            sx={{ color: '#0b85c8', padding: '8px' }}
                        >
                            <ViewColumnIcon />
                        </IconButton>
                    </Tooltip>

                    {opencolspaper && (
                        <Paper
                            elevation={3}
                            sx={{
                                p: 2,
                                zIndex: 1300,
                                borderRadius: 2,
                                position: 'absolute',
                                top: { lg: '160px', xs: '255px', sm: '215px', md: '215px' },
                                right: '25px',
                                width: { xs: '280px', sm: '320px', md: '280px' },
                                maxWidth: '320px',
                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontFamily: 'Open Sans',
                                        fontWeight: 600,
                                        color: '#0b85c8',
                                        fontSize: { xs: '13px', sm: '14px', md: '15px' },
                                    }}
                                >
                                    Customize Columns
                                </Typography>
                                <IconButton onClick={() => setOpencolspaper(false)} size="small">
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </Box>
                            <Box sx={{ mb: 1 }}>
                                <Button
                                    variant="text"
                                    onClick={() => {
                                        const allSelected = columns.every(column => !column.hide);
                                        if (allSelected) {
                                            const updatedColumns = columns.map(column => ({ ...column, hide: true }));
                                            setColumns(updatedColumns);
                                            setColumnOrder([]);
                                        } else {
                                            const updatedColumns = columns.map(column => ({ ...column, hide: false }));
                                            setColumns(updatedColumns);
                                            setColumnOrder(columns.map(column => column.field));
                                        }
                                    }}
                                    sx={{
                                        fontFamily: 'Open Sans',
                                        fontSize: { xs: '11px', sm: '12px', md: '13px' },
                                        textTransform: 'none',
                                        color: '#0b85c8',
                                        p: 0,
                                        minWidth: 'auto',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                            textDecoration: 'underline'
                                        }
                                    }}
                                >
                                    {columns.every(column => !column.hide) ? 'Unselect All' : 'Select All'}
                                </Button>
                            </Box>
                            <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
                                {columns.map((column) => (
                                    <Box key={column.field} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <Checkbox
                                            checked={!column.hide}
                                            onChange={(e) => {
                                                const updatedColumns = columns.map((col) =>
                                                    col.field === column.field ? { ...col, hide: !e.target.checked } : col
                                                );
                                                setColumns(updatedColumns);
                                                if (e.target.checked) {
                                                    setColumnOrder((prev) => {
                                                        if (!prev.includes(column.field)) {
                                                            return [...prev, column.field];
                                                        }
                                                        return prev;
                                                    });
                                                } else {
                                                    setColumnOrder((prev) => prev.filter(field => field !== column.field));
                                                }
                                            }}
                                            sx={{ mr: 1, p: 0.5 }}
                                        />
                                        <Typography
                                            sx={{
                                                fontFamily: 'Open Sans',
                                                fontSize: { xs: '12px', sm: '13px', md: '14px' },
                                            }}
                                        >
                                            {column.headerName || column.field}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Paper>
                    )}
                </Box>
            </Box>

            <Box sx={{
                overflowX: 'auto',
                width: '100%'
            }}>
                <ReusableTable
                    columns={filteredColumns}
                    rows={filteredRows}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    pdf={pdf}
                    onPdf={handlepdf}
                    editicon={editicon}
                    deleteicon={deleteiocn}
                    onApplyFilters={(activeFilters) => {
                        setAppliedFilters(activeFilters);
                    }}
                    onPaginationChange={handlePaginationChange}
                    totalrows={totalrows}
                    onSelectionChange={(ids) => setSelectedIds(ids)}
                />
            </Box>

            <Dialog open={openServiceDialog} maxWidth="sm" fullWidth>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ backgroundColor: '#f0f9ff' }}>
                    <DialogTitle sx={{ fontFamily: 'Open Sans', color: '#0b85c8', margin: 'auto', fontWeight: 600 }}>
                        {editingServiceId ? 'Edit Product' : 'Add New Product'}
                    </DialogTitle>
                    <IconButton onClick={() => setOpenServiceDialog(false)} sx={{ color: '#fff' }}>
                        <CloseIcon sx={{ bgcolor: '#0b85c8', borderRadius: 2, mr: 2 }} />
                    </IconButton>
                </Box>
                <DialogContent sx={{ backgroundColor: '#f0f9ff', mt: -2 }}>
                    <Box p={1} sx={{ backgroundColor: '#fff', borderRadius: 2, boxShadow: '1px 1px 10px #888' }}>
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            gap: 2,
                            p: 2,
                        }}>
                            <TextField
                                label="Product Name"
                                name="serviceName"
                                value={formData.serviceName}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                sx={{ width: { lg: '48%' } }}
                                error={!!errors.serviceName}
                                helperText={errors.serviceName}

                            />
                            <TextField
                                select
                                label="Product Category"
                                name="serviceCategory"
                                value={formData.serviceCategory}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                sx={{ width: { lg: '48%' } }}
                                error={!!errors.serviceCategory}
                                helperText={errors.serviceCategory}



                            >
                                {categoryData?.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.value.charAt(0).toUpperCase() + item.value.slice(1).toLowerCase()}
                                    </MenuItem>
                                ))}
                            </TextField>

                            <TextField
                                label="Base Price"
                                name="basePrice"
                                type="number"
                                value={formData.basePrice}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                }}
                                sx={{ width: { lg: '48%' } }}
                                error={!!errors.basePrice}
                                helperText={errors.basePrice}


                            />
                            <TextField
                                label="Duration"
                                name="duration"
                                placeholder='Insert Duration In Days'
                                value={formData.duration}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                sx={{ width: { lg: '48%' } }}
                                error={!!errors.duration}
                                helperText={errors.duration}


                            />

                            <TextField
                                label="Tax"
                                name="taxRate"
                                value={formData.taxRate}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                sx={{ width: { lg: '48%' } }}


                            />
                            <TextField
                                label="Total Amount (₹)"
                                name="totalAmount"
                                value={formData.totalAmount}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                sx={{ width: { lg: '48%' } }}


                                InputProps={{
                                    readOnly: true,
                                    startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                }}

                            />

                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <Button
                            variant="contained"
                            onClick={handleServiceSubmit}
                            fullWidth
                            sx={{ backgroundColor: '#0b85c8', fontFamily: 'Open Sans', width: 'max-content', borderRadius: 2, boxShadow: 3 }}
                        >
                            {editingServiceId ? 'Update Product' : 'Submit Product'}
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </Container>
    );
}